export const BASE_URL = process.env["BASE_URL"] || "";
export const AUTH0_DOMAIN = process.env["AUTH0_DOMAIN"] || "";
export const AUTH0_DOMAIN_SECONDARY = process.env["AUTH0_DOMAIN_SECONDARY"] || "";
export const AUTH0_CLIENT_ID = process.env["AUTH0_CLIENT_ID"] || "";
export const AUTH0_AUDIENCE = process.env["AUTH0_AUDIENCE"] || "";
export const AUTH0_DATABASE_NAME = process.env["AUTH0_DATABASE_NAME"] || "";
export const BROADCAST_CHAT_SOCKET_URL =
  process.env["BROADCAST_CHAT_SOCKET_URL"] || "";
export const DMS_CHAT_SOCKET_URL = process.env["DMS_CHAT_SOCKET_URL"] || "";
export const NOTIFICATION_SOCKET_URL =
  process.env["NOTIFICATION_SOCKET_URL"] || "";
export const TENOR_API_KEY = process.env["TENOR_API_KEY"] || "";
export const AUTH0_CLIENT_SECRET = process.env["AUTH0_CLIENT_SECRET"];
export const ONE_SIGNAL_API_KEY = process.env["ONE_SIGNAL_API_KEY"];
export const DEFAULT_FILTER = "trending";
export const PRIVY_APP_ID_KEY = process.env["PRIVY_APP_ID_KEY"] || "";
export const SOLANA_FEED_ACCOUNT = process.env["SOLANA_FEED_ACCOUNT"] || "";
export const SOLANA_PG_AUTHORITY = process.env["SOLANA_PG_AUTHORITY"] || "";
export const SOLANA_RPC_URL = process.env["SOLANA_RPC_URL"] || "";
export const VIRTUOSO_SUBSCRIPTION_KEY = process.env["VIRTUOSO_SUBSCRIPTION_KEY"];
export const SOLANA_ADDRESS = "So11111111111111111111111111111111111111112"
export const SOLANA_ALTER_ADDRESS = "So11111111111111111111111111111111111111111";
export const WRAPPED_BNB_ADDRESS = "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c";
export const WRAPPED_SONIC_ADDRESS = "0x039e2fB66102314Ce7b64Ce5Ce3E5183bc94aD38";
export const ETH_BASE_CHAIN_ADDRESS = "0x4200000000000000000000000000000000000006";
export const WRAPPED_ETH_ADDRESS = "0xC02aaa39b223FE8D0A0e5C4F27ead9083C756Cc2";
export const NATIVE_TOKEN_COMMON_ADDRESS = "0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE"
export const API_KEY_DECRYPTOR = process.env["API_KEY_DECRYPTOR"] || "";
export const ENVIRONMENT = process.env["ENVIRONMENT"] || "development";
export const TOKEN_CREATION_FEE = 0.01011;
export const BIRD_EYE_API_KEY = process.env["BIRD_EYE_API_KEY"] || "";
export const BSC_RPC_URL = process.env["BSC_RPC_URL"] || "";
export const BASE_RPC_URL = process.env["BASE_RPC_URL"] || "";
export const SONIC_RPC_URL = process.env["SONIC_RPC_URL"] || "";
export const MORALIS_API_KEY = process.env["MORALIS_API_KEY"] || "";
export const ETHEREUM_RPC_URL = process.env["ETHEREUM_RPC_URL"] || "";
export const LAMPORTS_PER_EVM = 1000000000000000000;
export const SOLANA_USDT_MINT = "Es9vMFrzaCERmJfrF4H2FYD4KCoNkY11McCe8BenwNYB"; // USDT Token Mint
export const NEXTJS_SERVER_BASE_URL = process.env["NEXTJS_SERVER_BASE_URL"] || "";
